import { useState ,useEffect,useContext} from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "../../AppContext";

export default function Project() {
  const { data } = useContext(AppContext);
  const [detailNav, setdetailNav] = useState(2);
  const { projectId } = useParams();
  function linkClick (index){
    let a = document.createElement("a")
    a.href = '/#/project/'+ detailNav + '/' + index
    a.click()
  }
  useEffect(() => {
    if(projectId == 1 || projectId==2|| projectId==3){
setdetailNav(projectId)

    }

  })
  return (
    <div className="" id="pProject">
      <img src={"/image/"+detailNav+".png"} className="pageTitle"/>
      <div className="tabBar">
        <a href="/#/2" onClick={() => setdetailNav(2)} className={detailNav == 2 ? "router-link-exact-active router-link-active active":""}>头皮管理</a>
         <a href="/#/1" onClick={() => setdetailNav(1)} className={detailNav == 1 ? "router-link-exact-active router-link-active active":""} aria-current="page">皮肤管理</a>
        <a href="/#/3" onClick={() => setdetailNav(3)} className={detailNav == 3 ? "router-link-exact-active router-link-active active":""}>身体智能管理</a> 
        </div>
          <div  className="tabContent clearfix">
            {
              data?.project[detailNav].map((val,index)=>
                <div  className="" key={index} onClick={() => linkClick(index)}>
                  <div  className="imgBox">
                    <img  src={val.cover} alt=""/>
                  </div>
                  <p  className="proTit">{val.coverdetail}</p>
                  <p  className="proText">{val.title} {val.timecover ? (val.time+"分钟") : ""}</p>
                </div>
              )
            }
        </div>
    </div>
  );
}